import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-badge',
  components: {},
})
export default class DisplayFieldBadge extends mixins(AbstractDisplayField) {
  get variant(): string {
    const item = this.fieldConfig.valueToVariant?.find(item => item.value === this.value);
    return item?.variant || this.fieldConfig.defaultVariant || 'info';
  }

  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);
    return item?.label || item?.text || this.value;
  }

  get showDataHoverIcon() {
    return this.fieldConfig.dataHoverIcon
      ? Object.keys(this.fieldConfig.dataHoverIcon).length > 0
      : false;
  }

  get hoverIcon() {
    const data = this.fieldConfig.dataHoverIcon;
    return data['icon'];
  }

  get hoverData() {
    const data = this.fieldConfig.dataHoverIcon;
    return this.item[data['data']];
  }

  get dateInfo() {
    const field = this.fieldConfig.dateInfo;
    if (!field) {
      return null;
    }
    const date = this.item[field];

    return date ? this.formatDateTime(date) : null;
  }

  formatDateTime(value): string {
    return this.$bpcHelper.formatDateTimeV2(this.$bpcHelper.getDateDbStrV2(value));
  }
}
